(function () {
  let processForm = document.querySelector(".js-processes");

  if (processForm) {
    processForm.addEventListener("click", function (event) {
      if (event.target.matches(".js-add-process")) {
        let clickedButton = event.target;
        let originalForm = clickedButton.closest(".js-evaluation-form");
        const formType = originalForm.querySelector(
          'input[type="hidden"][name*="measure_type"]'
        ).value;
        let clonedSection = originalForm
          .querySelector(".simple-card")
          .cloneNode(true);
        let regex = /(\d+)-(\d+)/;
        let total;
        let status = clonedSection.querySelector(".status-bar");
        status.hidden = true;
        status.setAttribute("aria-hidden", true);
        let textNode = status.firstChild;

        if (formType.toLowerCase() === "impact") {
          total = originalForm.querySelector(
            'input[type="hidden"][name*="TOTAL_FORMS"][name*="impact"]'
          );
          textNode.textContent = "Impact added";
        } else {
          total = originalForm.querySelector(
            'input[type="hidden"][name*="TOTAL_FORMS"][name*="process"]'
          );
          textNode.textContent = "Process added";
        }

        let formCount = parseInt(total.value);

        let originalFieldId, originalFieldName;

        clonedSection
          .querySelectorAll("input:not([type=hidden]), textarea, select")
          .forEach(function (input) {
            input.value = "";
            const parent = input.closest(".fieldWrapper");
            const child = parent.querySelector(".fieldErrorWrapper");
            const label = parent.querySelector("label");
            child.classList.remove("error");
            child.innerHTML = "";
            originalFieldId = input.getAttribute("id");
            originalFieldName = input.getAttribute("name");
            if (originalFieldId && originalFieldName) {
              let fieldCount = formCount;
              let newId = originalFieldId.replace(
                regex,
                function (match, firstNumber) {
                  return firstNumber + "-" + fieldCount;
                }
              );
              let newName = originalFieldName.replace(
                regex,
                function (match, firstNumber) {
                  return firstNumber + "-" + fieldCount;
                }
              );
              input.setAttribute("id", newId);
              input.setAttribute("name", newName);
              label.setAttribute("for", newId);
            }
          });
        clonedSection
          .querySelectorAll("input[type=hidden]")
          .forEach(function (input) {
            originalFieldId = input.getAttribute("id");
            originalFieldName = input.getAttribute("name");
            if (originalFieldName) {
              // Check if the field should be deleted
              const shouldDelete =
                originalFieldName.endsWith("id") ||
                originalFieldName.endsWith("short_description") ||
                originalFieldName.endsWith("name");

              if (shouldDelete) {
                input.remove(); // Remove the input element
              } else {
                let fieldCount = formCount;
                let newId = originalFieldId.replace(
                  regex,
                  function (match, firstNumber) {
                    return firstNumber + "-" + fieldCount;
                  }
                );
                let newName = originalFieldName.replace(
                  regex,
                  function (match, firstNumber) {
                    return firstNumber + "-" + fieldCount;
                  }
                );

                input.setAttribute("id", newId);
                input.setAttribute("name", newName);
              }
            }
          });

        const preConfigued = clonedSection.querySelector(
          'input[type="hidden"][name*="is_pre_configured"]'
        );
        preConfigued.value = false;

        const shortDesc = clonedSection.querySelector(".field-desc");
        if (shortDesc) {
          shortDesc.remove();
        }

        let clonedEditButton = clonedSection.querySelector(".toggle-content");
        clonedEditButton.hidden = true;
        let originalControls = clonedEditButton.getAttribute("aria-controls");
        let originalLabel = clonedEditButton.getAttribute("aria-label");
        const secondNumber = formCount + 1;
        if (originalControls) {
          let newControls = originalControls.replace(
            regex,
            function (match, firstNumber) {
              return firstNumber + "-" + secondNumber;
            }
          );
          clonedEditButton.setAttribute("aria-controls", newControls);
        }
        if (originalLabel) {
          let newLabel = originalLabel.replace(
            regex,
            function (match, firstNumber) {
              return firstNumber + "-" + secondNumber;
            }
          );
          clonedEditButton.setAttribute("aria-label", newLabel);
        }

        let newField = document.createElement("div");
        let newFieldId = originalFieldId.replace(
          regex,
          function (match, firstNumber) {
            return firstNumber + "-" + formCount + "-name";
          }
        );
        let newFieldName = originalFieldName.replace(
          regex,
          function (match, firstNumber) {
            return firstNumber + "-" + formCount + "-name";
          }
        );
        newFieldId = newFieldId.replace(/-[^-]*$/, "");
        newFieldName = newFieldName.replace(/-[^-]*$/, "");

        let newFieldTitle;
        if (formType && formType.toLowerCase() === "impact") {
          newFieldTitle = "Impact measure title";
        } else {
          newFieldTitle = "Process measure title";
        }
        newField.className = "fieldWrapper form-control";
        newField.innerHTML = `
          <div class="fieldInputWrapper">
            <label class="label" for="${newFieldId}">${newFieldTitle}</label>
            <input type="text" required="true" id="${newFieldId}" name="${newFieldName}" class="form-control">
          </div>
          <div class="fieldErrorWrapper "></div>
        `;

        let formContentWrapper = clonedSection.querySelector(".full-content");
        let originalId = formContentWrapper.getAttribute("id");
        let newId = originalId.replace(regex, function (match, firstNumber) {
          return firstNumber + "-" + secondNumber;
        });
        formContentWrapper.setAttribute("id", newId);
        formContentWrapper.insertBefore(
          newField,
          formContentWrapper.firstChild
        );

        const checkbox = clonedSection.querySelector(".js-selected-field");
        if (checkbox) {
          checkbox.hidden = true;
        }

        let clonedFullContent = clonedSection.querySelector(".full-content");
        clonedFullContent.removeAttribute("hidden");
        clonedFullContent.setAttribute("aria-hidden", "false");

        let clonedUpdateButton = clonedSection.querySelector(".btn-primary");
        clonedUpdateButton.textContent = "Save";

        clonedUpdateButton.addEventListener("click", function () {
          const spanElement = checkbox.querySelector(".choice-label span");
          const checkboxInput = checkbox.querySelector(
            "input[type='checkbox']"
          );
          spanElement.textContent = newField.querySelector("input").value;

          // Set both values
          checkboxInput.checked = true; // Set checked state
          checkboxInput.value = "true"; // For backend
          checkboxInput.setAttribute("checked", "checked"); // For frontend styling
          checkbox.removeAttribute("hidden");
        });

        total.value = parseInt(total.value) + 1;

        let cancelButton = document.createElement("button");
        cancelButton.type = "button";
        cancelButton.textContent = "Cancel";
        cancelButton.className = "btn-tertiary";

        cancelButton.addEventListener("click", function () {
          cancelButton.closest(".simple-card").remove();
          total.value = parseInt(total.value) - 1;
        });

        let ctaContainer = clonedSection.querySelector(".cta-container");
        ctaContainer.insertBefore(
          cancelButton,
          ctaContainer.querySelector(".btn-primary")
        );

        const errorElement = clonedSection.querySelector(".error-message");
        if (errorElement) {
          errorElement.remove();
        }

        let addButton = event.target;
        addButton.parentNode.insertBefore(clonedSection, addButton);

        let stepTitleInput = clonedSection.querySelector("input[type='text']");
        if (stepTitleInput) {
          stepTitleInput.focus();
        }
      }
    });
  }
})();
